import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import {Toast} from 'vant'
import Qs from 'qs'
import router from '../router'
import store from '../store'
import state from '../store/state'
import {loginInfo} from '../common/js/loginInfo'
import {getAssignKeyLocationSearch, decode} from '../common/js/tools'
/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
axios.defaults.baseURl = process.env.VUE_APP_API_ADMIN
axios.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    // config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    // const token = localStorage.getItem('token');
    const token = state.user.loginToken
    const ClientType = state.ClientType
    if (token) {
        config.headers['LoginToken'] = token
    }
    if (ClientType) {
        config.headers['ClientType'] = ClientType
    }
    if (getAssignKeyLocationSearch('apptoken')) {
        config.headers['AppToken'] = getAssignKeyLocationSearch('apptoken')
    }
    if (getAssignKeyLocationSearch('appflag', ['appByDM'])) {
        if (getAssignKeyLocationSearch('appflag') === 'appByDM') {
            config.headers['AppType'] = 11
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
})
// console.log('process.env.BASE_URL',process.env)
axios.interceptors.response.use(response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    return Promise.resolve(response)
}, error => {
    store.commit('SET_LOADING', false)
    // 服务器返回不是 2 开头的情况，会进入这个回调
    // 可以根据后端返回的状态码进行不同的操作
    // console.log('error:', error)
    const responseCode = error.response.status
    switch (responseCode) {
    case 401: // 401：未登录
        if (state.ClientType == 1) {
            store.commit('SET_LOGINPOP', true) // 打开登录弹窗
        } else {
            router.push({name: 'MLogin'})
        }
        // Message({type: 'error', message: '未登录，请重新登录'})
        // router.replace({path: '/login', query: {redirect: router.currentRoute.fullPath}})
        break
    case 403: // 403: token过期
        Message({type: 'error', message: '登录信息过期，请重新登录'})
        localStorage.removeItem('token')
        // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        setTimeout(() => {
            router.replace({path: '/login', query: {redirect: router.currentRoute.fullPath}
            })
        }, 1000)
        break
    case 404: // 404请求不存在
        // Message({message: '网络请求不存在', type: 'error'})
        break
    case 500: // 其他错误，直接抛出错误提示
        Message({message: '服务器错误', type: 'error'})
        break
    
    default:
        if (state.ClientType == 1) {
            Message({message: error.response.data.message, type: 'error'})
        } else {
            Toast.fail(error.response.data.message)
        }
    }
    return Promise.reject(error)
})
/**
 url: 接口地址
 data: 参数
 success：请求正确回调函数
 error：请求错误回调函数
 */
export const post = function(url, param, success, error, config, isaes) {
    axios.post(url, Qs.stringify(param), config).then(function (response) {
        const responseCode = response.status
        if (responseCode === 200) {
            if (response.data.code === '000' || response.data.fname || response.data.code === '200' || response.data.code === '00') {
                if (isaes) {
                    success(JSON.parse(decode(response.data.data)))
                } else {
                    success(response.data)
                }
            } else {
                store.commit('SET_LOADING', false)
                let errorCode = response.data.code
                switch (errorCode) {
                case '401':
                    if (state.ClientType == 1) {
                        store.commit('SET_LOGINPOP', true) // 打开登录弹窗
                        window.sessionStorage.clear()
                        let user = {
                            innerid: '',
                            loginToken: '',
                            loginname: '',
                            logourl: '',
                            mobile: '',
                            name: '',
                            nickname: '',
                            isLogin: false
                        }
                        store.commit('SET_USER', user)
                        _delCookie('token')
                    } else if (state.ClientType == 2) {
                        router.push({name: 'MLogin'})
                        window.sessionStorage.clear()
                        let user = {
                            innerid: '',
                            loginToken: '',
                            loginname: '',
                            logourl: '',
                            mobile: '',
                            name: '',
                            nickname: '',
                            isLogin: false
                        }
                        store.commit('SET_USER', user)
                        _delCookie('token')
                    } else {
                        loginInfo()
                    }
                    // Message({type: 'error', message: response.data.msg})
                    // router.push('/login')
                    break
                case '999':
                    if (state.ClientType == 1) {
                        Message({message: response.data.msg ? response.data.msg : response.data.mesg, type: 'error'})
                    } else {
                        Toast.fail(response.data.msg ? response.data.msg : response.data.mesg)
                    }
                    break
                case '405':
                    MessageBox.confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                        confirmButtonText: '去购买',
                        cancelButtonText: '取消'
                    }).then(() => {
                        // 去购买
                        router.push({name: 'OrderService', query: {tabs: 'functionalService'}})
                    })
                    break
                case '998':
                    if (state.ClientType == 1) {
                        Message({message: response.data.msg ? response.data.msg : response.data.mesg, type: 'error'})
                    } else {
                        Toast.fail(response.data.msg ? response.data.msg : response.data.mesg)
                    }
                    break
                default: error(response.data)
                }
            }
        } else {
            error(error.response.data)
        }
    }).catch(error => {
        console.log(error)
    })
}
export const postJson = function(url, param, success, error, isaes) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    axios.post(url, param, config).then(function (response) {
        const responseCode = response.status
        if (responseCode === 200) {
            if (response.data.code === '000' || response.data.fname) {
                if (isaes) {
                    success(JSON.parse(decode(response.data.data)))
                } else {
                    success(response.data)
                }
            } else {
                store.commit('SET_LOADING', false)
                let errorCode = response.data.code
                switch (errorCode) {
                    case '401':
                        if (state.ClientType == 1) {
                            store.commit('SET_LOGINPOP', true) // 打开登录弹窗
                            window.sessionStorage.clear()
                            let user = {
                                innerid: '',
                                loginToken: '',
                                loginname: '',
                                logourl: '',
                                mobile: '',
                                name: '',
                                nickname: '',
                                isLogin: false
                            }
                            store.commit('SET_USER', user)
                            _delCookie('token')
                            // Message({message: response.data.msg ? response.data.msg : response.data.mesg, type: 'error'})
                        } else if (state.ClientType == 2) {
                            router.push({name: 'MLogin'})
                            window.sessionStorage.clear()
                            let user = {
                                innerid: '',
                                loginToken: '',
                                loginname: '',
                                logourl: '',
                                mobile: '',
                                name: '',
                                nickname: '',
                                isLogin: false
                            }
                            store.commit('SET_USER', user)
                            _delCookie('token')
                            // Toast.fail(response.data.msg ? response.data.msg : response.data.mesg)
                        } else {
                            loginInfo()
                        }
                        // router.push('/login')
                        break
                    case '999':
                        if (state.ClientType == 1) {
                            Message({message: response.data.msg ? response.data.msg : response.data.mesg, type: 'error'})
                        } else {
                            Toast.fail(response.data.msg ? response.data.msg : response.data.mesg)
                        }
                        break
                    case '405':
                        MessageBox.confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                            confirmButtonText: '去购买',
                            cancelButtonText: '取消'
                        }).then(() => {
                            // 去购买
                            router.push({name: 'OrderService', query: {tabs: 'functionalService'}})
                        })
                        break
                    case '998':
                        if (state.ClientType == 1) {
                            Message({message: response.data.msg ? response.data.msg : response.data.mesg, type: 'error'})
                        } else {
                            Toast.fail(response.data.msg ? response.data.msg : response.data.mesg)
                        }
                        break
                    default: error(response.data)
                }
            }
        } else {
            error(error.response.data)
        }
    }).catch(error => {
        console.log(error)
    })
}
// form格式请求 下载文件
export const formDownload = function(url, param, name, success, error) {
  const config = {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}, responseType: 'arraybuffer'}
  axios.post(url, Qs.stringify(param), config).then(function (response) {
    if (response.status === 200) {
      const blob = new Blob([response.data]) // 处理文档流
      const fileName = name
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
      success('下载成功')
    } else {
      error(response.data)
    }
  }).catch(error => {
    console.log(error)
  })
}
export const downFile = function(url, param, success, error, EventId) {
    let config = {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','EventId': EventId}, responseType: 'blob'}
    axios.post(url, Qs.stringify(param), config).then(function (res) {
        if (res.status === 200) {
            if (res.headers.export === 'false' || !!res.headers.export) {
                store.commit('SET_LOADING', false)
                Message({type: 'error', message: '导出数据为空,请重新导出！'})
            } else {
                success(res.data)
            }
        } else {
            Message.error('系统错误，请联系管理员')
        }
    })
}

export const postfile2 = function(url, param, success, error, EventId) {
    let config = {headers: {'Content-Type': 'multipart/form-data', 'EventId':EventId}}
    axios.post(url, param, config).then(function (res) {
        if (res.status === 200) {
            let data = res.data
            if (data.code === '000' || data.fname) {
                success(data)
            } else {
                error(data)
            }
        } else {
            Message.error('系统错误，请联系管理员')
        }
    }).catch(error => {
        console.log(error)
    })
}


// 七牛上传图片
export const postfile = function(url, param, success, error) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}}
    axios.post(url, param, config).then(function (res) {
        if (res.status === 200) {
            let data = res.data
            if (data.code === '000' || data.fname) {
                success(data)
            } else {
                error(data)
            }
        } else {
            Message.error('系统错误，请联系管理员')
        }
    }).catch(error => {
        console.log(error)
    })
}

export function get(url, param, success, error) {
    axios.post(url, param).then(function (res) {
        if (res.status === 200) {
            let data = res.data
            if (data.code === '000') {
                success(data)
            } else {
                error(data)
            }
        } else {
            Message.error('系统错误，请联系管理员')
        }
    }).catch(error => {
        console.log(error)
    })
}
function _setCookie(key, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = key + '=' + value
    + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    + ';path=/'
    + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
}
function _delCookie(key) {
    _setCookie(key, "", -1);
}
